if (!customElements.get('info-boxes')) {
  class InfoBoxes extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        toggleHandler: '.js-toggle-box-content',
        description: '.info-boxes__description',
        infoBox: '.info-boxes__item',

        infoBoxActiveClass: 'info-boxes__item--active'
      }

      this.toggleHandlers = this.querySelectorAll(this.selectors.toggleHandler);

      this.toggleHandlers.forEach((handler) => {
        handler.addEventListener('click', this.toggleAccordion.bind(this));
      });
    }

    toggleAccordion(e) {
      const target = e.currentTarget;
      const targetInfoBox = target.closest(this.selectors.infoBox);
      const targetDescription = targetInfoBox.querySelector(this.selectors.description);

      if (targetInfoBox.classList.contains(this.selectors.infoBoxActiveClass)) {
        targetInfoBox.classList.remove(this.selectors.infoBoxActiveClass);
        targetDescription.style.height = '0px';
      } else {
        targetInfoBox.classList.add(this.selectors.infoBoxActiveClass);
        targetDescription.style.height = `${targetDescription.scrollHeight + 30}px`;
      }
    }
  }

  customElements.define('info-boxes', InfoBoxes);
}
